import React, {useState} from 'react'
import {Card, CardActionButton, CardHeader, SignInLayout} from '../components/SigninLayout'
import {FormattedMessage, useIntl} from "react-intl";

export const EmailChangeFinish = ({system}) => {
  const intl = useIntl()
  const searchParams = new URLSearchParams(window.location.search)
  const key = searchParams.get('key')
  const systemId = searchParams.get('systemId') || (system && system.systemId)
  const locale = searchParams.get('locale') || intl.locale
  const hasValidParams = !!(key && systemId)
  const finishUrl = `/pasapi/account/email-change/finish?locale=${encodeURIComponent(locale || '')}`
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const onConfirmEmailChange = () => {
    if (!hasValidParams || isLoading) {
      return
    }

    setIsLoading(true)
    setErrorMessage('')

    fetch(finishUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({key, systemId}),
      })
      .then(response => {
        console.log('Email change finish response:', response)
        if (response.redirected && response.url) {
          window.location = response.url
        } else if (response.ok) {
          window.location = `/change-email-success?systemId=${encodeURIComponent(systemId)}&locale=${encodeURIComponent(locale)}`
        }
      })
      .catch((error) => {
        console.error('Email change finish error:', error)
        const message = error && error.message
        if (message === 'error.keyExpired') {
          setErrorMessage(intl.formatMessage({
            defaultMessage: 'This confirmation link has expired. Please request a new email change from your account settings.',
            description: 'Email change expired link error'
          }))
        } else {
          setErrorMessage(intl.formatMessage({
            defaultMessage: 'We could not confirm your email change. Please try again later.',
            description: 'Email change generic confirmation error'
          }))
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return <SignInLayout system={system}>
    <Card centralizedContent>
      <CardHeader>
        <h1><FormattedMessage
          defaultMessage="Confirm your email change"
          description="Email change confirmation title"
        /></h1>
        <p><FormattedMessage
          defaultMessage="For security reasons, please click the button below to confirm your email change."
          description="Email change confirmation instructions"
        /></p>
      </CardHeader>
      {
        hasValidParams
          ? <>
              {errorMessage && <p>{errorMessage}</p>}
              <CardActionButton type="button" onClick={onConfirmEmailChange} isLoading={isLoading} highlight>
                <FormattedMessage
                  defaultMessage="Confirm email change"
                  description="Email change confirmation button"
                />
              </CardActionButton>
            </>
          : <p><FormattedMessage
            defaultMessage="This confirmation link is invalid or incomplete."
            description="Email change invalid link message"
          /></p>
      }
    </Card>
  </SignInLayout>
}
